import { useGetNotificationPreferencesQuery } from 'api/notification-center/notificationCenter'
import { canSeeNotifications } from 'data/permissions/permissionsSelectors'

/**
 * Whether this user can receive notifications at all — permission only, now that the rollout flag is
 * gone. The bell is the only thing that hears a run finish, so anything that would *promise* a
 * notification asks this rather than assuming the answer.
 */
export const useIsNotificationCenterAvailable = (): boolean => canSeeNotifications()

/**
 * Whether one producer's notification would actually reach this user: the server drops the write when
 * the recipient's toggle is off, the queued event included, so the asynchronous route needs the
 * preference and not just the permission. Preferences still loading read as unreachable — the
 * synchronous route at least reports its own outcome.
 */
export const useCanReceiveNotification = (prefKey: string): boolean => {
  const isAvailable = useIsNotificationCenterAvailable()
  const { data: preferences } = useGetNotificationPreferencesQuery(undefined, { skip: !isAvailable })

  if (!preferences) return false
  // A producer with no row is at the catalog's default, which is on.
  return preferences.find(preference => preference.prefKey === prefKey)?.enabled !== false
}

export default useIsNotificationCenterAvailable
